<template>
  <div class="v-dropdown-filter" :class="{ multiple: isMultiple }">
    <dropdown-menu
      v-model="show"
      :hover="false"
      :close-on-click-outside="true">
      <button class="dropdown-toggle no-margin">
        <div class="grid-x align-middle">
          <div class="cell auto">
            {{ options.label }} 
            <span v-if="hasValue">({{ value.length }})</span>
          </div>
          <div class="cell shrink">
            <span 
              v-html="$icons.get('caret_down', 'black small')" 
              style="margin-left:.3rem">
            </span>
          </div>
        </div>
      </button>
      <div slot="dropdown">
        <div v-if="isMultiple" class="dropdown-apply">
          <div class="grid-x align-middle">
            <div class="cell auto">
              <button 
                class="btn btn-dark-gray btn-hollow btn-expanded no-margin" 
                :class="{ 'btn-disabled': !selected.length }"
                @click.prevent="setFilter">
                Apply selected ({{ selected.length }})
              </button>
            </div>
            <div class="cell shrink">
              <button 
                class="btn btn-white" 
                :class="{ 'btn-disabled': !selected.length }"
                style="margin:0 0 0 .25rem"
                :title="'Remove filter' + (selected.length !== 1 ? 's' : '')"
                @click.prevent="deselectAll">
                <span 
                  v-html="$icons.get('filter_x', (selected.length ? 'medium black' : 'medium light-gray'))"></span>
              </button>
            </div>
          </div>
        </div>
        
        <ul class="detached" style="margin: 0;padding:0">
          <li
            v-for="(item, index) in options.source"
            :class="{ 'is-active': isItemActive(item) }"
            :key="index">
            <a 
              href="#"
              @click.prevent="selectItem(item)"
              class="dropdown-item">
              <div class="grid-x align-middle" style="line-height:1">
                <div class="cell shrink">
                  <span 
                    v-html="$icons.get(isItemActive(item) ? 'circle_check' : 'circle', 'black small')" 
                    style="margin-right:.5rem">
                  </span>
                </div>
                <div class="cell auto">
                  {{ item.label }}
                </div>
              </div>
            </a>
          </li>
        </ul>
      </div>
    </dropdown-menu>
  </div>
</template>

<script>
import {_} from 'vue-underscore'
import DropdownMenu from '@innologica/vue-dropdown-menu'

export default { 
  name: 'DropdownFilter',
  components: {
    DropdownMenu
  },
  props: {
    options: {
      type: Object,
      required: true
    },
    value: {
      type: [Array, Number, String]
    }
  },
  data () {
    return {
      selected: [],
      show: false
    }
  },
  methods: {
    // Check if an item is currently selected
    isItemActive (item) {
      if (this.isMultiple) {
        return _.find(this.selected, function(selected_item) {
          return selected_item == item.id
        })
      } else {
        return this.selected == item.id
      }
    },
    // Select (or deselect) and item
    selectItem (item) {
      if (this.isItemActive(item)) {
        this.selected = _.reject(this.selected, function(selected_item) {
          return selected_item == item.id
        })
      } else {
        if (this.isMultiple) {
          this.selected.push(item.id)
        } else {
          this.selected = item.id
          this.setFilter()
        }
      }
    },
    // Apply the current filter
    setFilter () {
      this.show = false
      this.$emit('update-filter', { key: this.options.name, value: this.selected })
    },
    // Reset the filter
    deselectAll () {
      this.selected = []
      this.setFilter()
    }
  },
  computed: {
    hasValue () {
      return (this.value && this.value.length)
    },
    isMultiple () {
      return this.options.multiple
    }
  },
  mounted () {
    if (this.value) {
      this.selected = JSON.parse(JSON.stringify(this.value))
    }
  }
}
</script>
